import { SpaceBetween, Spinner, SpinnerProps, TextContent } from "@amzn/awsui-components-react";
import { JSX } from "react";

/**
 * Interface that represents the props for the Loading Content component
 *
 * @property {string} loadingMessage - The message to display for loading
 * @property {SpinnerProps.Size} - The size of the spinner
 */
export interface LoadingContentProps {
    loadingMessage: string;
    size?: SpinnerProps.Size;
}

/**
 * Renders a wrapper a loading spinner with a text
 *
 * @property {string} loadingMessage - The message to display for loading
 * @property {SpinnerProps.Size} - The size of the spinner
 * @returns {JSX.Element} - The loading component
 */
const LoadingContent = ({ loadingMessage, size = "normal" }: LoadingContentProps): JSX.Element => {
    return (
        <SpaceBetween size="s" direction="horizontal">
            <Spinner size={size} />
            <TextContent>
                <p>{loadingMessage}</p>
            </TextContent>
        </SpaceBetween>
    );
};

export default LoadingContent;
